import React from "react";
import Link from "next/link";

export default function LogoSmall() {
	return (
		<Link passHref href="/">
			<img className="w-100" src={"/img/AAPL-LiL-Static.png"} alt="AAPL logo" />
		</Link>
	);
}
